import styles from './ProgressWheel.module.scss';

type ProgressWheelProps = {
  /**
   * The progress of the wheel, from 0 to 100.
   */
  percentage: number;
  /**
   * The title text for accesibility
   */
  titleText: string;
  size?: number;
};

type CircleProps = {
  percentage?: number;
  strokeWidth: string;
};

export const ProgressWheel = ({ percentage, titleText, size = 200 }: ProgressWheelProps) => {
  const Circle = ({ percentage = 0, strokeWidth }: CircleProps) => {
    const radius = 90;
    const circumference = 2 * Math.PI * radius;
    const stroke = ((100 - (percentage ?? 100)) * circumference) / 100;
    return (
      <circle
        className={styles.circle}
        r={radius}
        cx={100}
        cy={100}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={percentage !== 0 ? stroke : circumference}
      />
    );
  };

  const sanitisedPercentage = percentage < 0 ? 0 : percentage > 100 ? 100 : percentage;
  const title = `${titleText}: ${sanitisedPercentage}%`;
  return (
    <svg viewBox="0 0 200 200" width={size} height={size}>
      <title>{title}</title>
      <g transform="rotate(-90 100 100)">
        <Circle percentage={100} strokeWidth="0.1rem" />
        <Circle percentage={sanitisedPercentage} strokeWidth="1rem" />
      </g>
      <text className={styles.text} x="50%" y="50%" dominantBaseline="central">
        {percentage.toFixed(0)}%
      </text>
    </svg>
  );
};
